<template>
    <div class="section">
        <div class="bak">
            <h1 class="title is-size-2 is-size-3-mobile has-text-primary">Jobbe hos oss?</h1>
            <p class="is-size-5 is-size-6-mobile has-text-white">For øyeblikket har vi dessverre ingen ledige stillinger. </p>
        </div>
    </div>
</template>

<script>
export default {
    title: 'Jobbe her?',
    metaInfo: {
        meta: [
        { name: 'description', content: 'Ledige stillinger på General Hotell'},
        { name: 'keywords', content: 'Jobb, ledig stilling, kokk, servitør' }
        ]
    },        
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.7;
    display: block;
    padding: 10px 10px 30px 10px;
    margin-bottom:200px;
}

.avsnitt {
    margin-top:1.5vw;
}
</style>